import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { Container, Card, Row, Col, Button, Spinner, Alert, Table, Badge, Modal, Form, Pagination, ListGroup, InputGroup, Accordion } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useEntidadeContext } from '../EntidadeContext'; 
import { useUserContext } from '../UserContext';
import { useAuthContext } from '../context/AuthContext'; // Importar o contexto de autenticação
import axios from 'axios';
import ScheduleSummary from '../components/dashboard/ScheduleSummary.js'; // Importar o novo componente
import SubscriptionStatusCard from '../components/SubscriptionStatusCard.jsx'; // Usar .jsx se você consolidou os arquivos
import ComissaoRelatorio from '../components/dashboard/ComissaoRelatorio.js'; // Importar o novo componente de comissão
import { format } from 'date-fns';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import addPatientIcon from '../img/icoPlusPaciente.jpg';
import { useAlertModal } from '../AlertModalContext';

// Função para normalizar strings (remover acentos e converter para minúsculas) para a busca
const normalizeString = (str) => str ? str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() : '';

const DashboardPage = () => {
  const navigate = useNavigate();

  // --- DEBUG: Log para confirmar atualização em produção ---
  // useEffect(() => {
  // }, []);

  // OBTÉM TODOS OS DADOS DE SUPORTE E CONFIGURAÇÃO DO ENTIDADECONTEXT
  const { currentEntidade, agendaConfig, isLoadingAgendaConfig, supportData, isLoadingSupportData, isLoadingEntidade } = useEntidadeContext();
  const { currentUserRole, getPermittedHeaderTabs, getPermittedInternalTabs, isLoadingAccessConfig } = useUserContext();
  const { showAlertModal } = useAlertModal();
  const { authState, updatePartialSubscription, setSubscription, isLoggedIn, isFetchingSubscription, loggedInUser: currentUser } = useAuthContext(); // Importar o contexto de autenticação
  const [lowStockMaterials, setLowStockMaterials] = useState([]);
  // isLoading agora controla apenas o loading da verificação do estoque
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSubscription, setIsLoadingSubscription] = useState(true);
  // Novo estado para saber se a verificação foi feita e mostrar o resultado
  const [stockChecked, setStockChecked] = useState(false);
  // 3. Novo estado para o status das atribuições de perfil
  const [assignmentStatus, setAssignmentStatus] = useState({
    isLoading: true,
    hasReception: true, // Assume true para não mostrar o alerta por padrão
  });
  const assignmentsCheckedForEntityIdRef = useRef(null); // Ref para controlar a chamada da API
  const [isSyncing, setIsSyncing] = useState(false);
  // Novos estados para o histórico de compras
  const [purchaseHistory, setPurchaseHistory] = useState([]);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false); // Inicia como falso
  const [historyError, setHistoryError] = useState(null);
  const [historySearched, setHistorySearched] = useState(false); // Novo estado para controlar se a busca foi feita
  // Novos estados para o filtro de data
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
  const [startDate, setStartDate] = useState(firstDayOfMonth);
  const [endDate, setEndDate] = useState(today.toISOString().split('T')[0]);
  // Novos estados para a paginação do histórico
  const [historyCurrentPage, setHistoryCurrentPage] = useState(1);
  const [historyTotalPages, setHistoryTotalPages] = useState(0);
  // Novo estado para a soma total do período
  const [historyTotalSum, setHistoryTotalSum] = useState(0);

  // --- NOVOS ESTADOS PARA O MODAL DE AGENDAMENTO ---
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [isLoadingCreate, setIsLoadingCreate] = useState(false);
  const [newAppointment, setNewAppointment] = useState({
    entidade_id: null, filial_id: '', especialidade_id: '', medico_id: '',
    paciente_id: '', data_agendamento: null, hora_marcada: '', tipo: 'Consulta',
    status: 'Agendada', interesses: [],
  });
  const [newPatient, setNewPatient] = useState({
    nome: '', cpf: '', data_nascimento: '', sexo: '', email: '', dddcelular: '', celular: ''
  });
  const [allInteresses, setAllInteresses] = useState([]);
  const [pacientePacotesAtivos, setPacientePacotesAtivos] = useState([]);
  const [isLoadingPacotes, setIsLoadingPacotes] = useState(false);
  const [selectedPackageId, setSelectedPackageId] = useState(null);
  const [refreshSummary, setRefreshSummary] = useState(0);
  const [busyDoctorsForSlot, setBusyDoctorsForSlot] = useState([]);
  // Estados que agora vêm do `supportData` do contexto
  const { allFuncionarios, pacientesList, servicos, especialidades, todosMedicos } = supportData;
  const [selectedServicos, setSelectedServicos] = useState([]);
  const [pacienteSearch, setPacienteSearch] = useState('');
  const [showPacientesDropdown, setShowPacientesDropdown] = useState(false);
  const pacienteDropdownRef = useRef(null);
  const [showCreatePatientModal, setShowCreatePatientModal] = useState(false);

  const [isCreatingPatient, setIsCreatingPatient] = useState(false); // NOVO: Estado de loading

  // Estado para o modal da Central de Ajuda
  const [showHelpCenterModal, setShowHelpCenterModal] = useState(false);
  // Estados para controlar os vídeos ativos em cada categoria do Accordion da Central de Ajuda
  const [activeAgendaVideo, setActiveAgendaVideo] = useState(null);
  const [activePacientesVideo, setActivePacientesVideo] = useState(null);
  const [activeFinanceiroVideo, setActiveFinanceiroVideo] = useState(null);
  const [activePessoalVideo, setActivePessoalVideo] = useState(null);
  const [activeEstoqueVideo, setActiveEstoqueVideo] = useState(null);
  const [activeSegurancaVideo, setActiveSegurancaVideo] = useState(null);
  const [activeConfiguracoesVideo, setActiveConfiguracoesVideo] = useState(null);
  const [activeAssinaturaVideo, setActiveAssinaturaVideo] = useState(null);
  const [helpSearchTerm, setHelpSearchTerm] = useState('');

  // --- PERMISSÕES DO DASHBOARD ---
  const dashboardPermissions = useMemo(() => {
    return getPermittedInternalTabs('dashboard', currentUserRole);
  }, [getPermittedInternalTabs, currentUserRole, isLoadingAccessConfig]);

  const hasPermission = useCallback((key) => {
    return dashboardPermissions.some(tab => tab.key === key);
  }, [dashboardPermissions]);

  // NOVO: Funções auxiliares para verificar feriados e dias bloqueados
  const getFeriadoNome = useCallback((date) => {
    if (!date || !agendaConfig?.feriados) return null;
    const dateString = format(date, 'yyyy-MM-dd');
    const feriado = agendaConfig.feriados.find(f => f.data === dateString);
    return feriado ? feriado.descricao : null;
  }, [agendaConfig]);

  const isDiaBloqueado = useCallback((date) => {
    if (!date || !agendaConfig?.diasBloqueados) return false;
    const dateString = format(date, 'yyyy-MM-dd');
    return agendaConfig.diasBloqueados.some(b => b.data === dateString);
  }, [agendaConfig]);

  // Interceptor global para erros de assinatura, replicado para o Dashboard
  useEffect(() => {
    const responseInterceptor = axios.interceptors.response.use(
      (response) => response, // Passa adiante respostas de sucesso
      (error) => {
        // Verifica se o erro é de 'Forbidden' e se a mensagem é sobre assinatura inativa
        if (error.response && error.response.status === 403 && error.response.data?.message?.includes('Sua assinatura não está ativa')) {
          const message = error.response.data.message;

          // Exibe um modal para o usuário e oferece redirecionamento
          showAlertModal(
            'Assinatura Inativa',
            `${message} Clique em OK para ser redirecionado à página de planos.`,
            'warning',
            () => navigate('/pricing') // Ação ao clicar em OK
          );

          // Importante: Rejeita a promessa para que a chamada original da API ainda falhe
          return Promise.reject(error);
        }
        // Para todos os outros erros, apenas os repasse para serem tratados localmente
        return Promise.reject(error);
      }
    );

    // Função de limpeza para remover o interceptor quando o componente é desmontado
    return () => {
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, [showAlertModal, navigate]);

  // Efeito para verificar se a agenda foi configurada.
  useEffect(() => {
    // Roda apenas quando a entidade e a config da agenda terminarem de carregar.
    // E somente se o usuário for um Representante Legal.
    if (!isLoadingEntidade && !isLoadingAgendaConfig && currentEntidade && currentUserRole === 'Representante Legal') {
      
      // Verifica se o objeto de horários gerados existe e se algum dia da semana tem pelo menos um horário cadastrado.
      const horariosGerados = currentEntidade.agenda_horarios_gerados;
      const isAgendaConfigurada = horariosGerados && 
        Object.values(horariosGerados).some(dia => 
            (dia['Manhã'] && dia['Manhã'].length > 0) ||
            (dia['Tarde'] && dia['Tarde'].length > 0) ||
            (dia['Noite'] && dia['Noite'].length > 0)
        );

      // Se não estiver configurada, exibe o alerta.
      if (!isAgendaConfigurada) {
        showAlertModal(
          'Configuração da Agenda Pendente',
          'Os horários de atendimento da sua clínica ainda não foram definidos. Isso é essencial para usar a agenda. Clique em OK para configurar agora.',
          'warning',
          () => navigate('/configuracoes') // Redireciona para a página de configurações
        );
      }
    }
    // As dependências garantem que o efeito rode apenas quando os dados relevantes estiverem prontos.
  }, [currentEntidade, isLoadingEntidade, isLoadingAgendaConfig, currentUserRole, showAlertModal, navigate]);


  // Efeito para buscar os dados da assinatura quando o componente monta.
  useEffect(() => {
    // O AuthContext já busca a assinatura automaticamente.
    // Apenas sincronizamos o estado de loading local com o do contexto.
    setIsLoadingSubscription(isFetchingSubscription);
  }, [isFetchingSubscription]);

  // Função para buscar o histórico de compras sob demanda
  const handleFetchHistory = useCallback(async (page = 1) => { // Aceita o número da página
    // Apenas busca o histórico se o usuário for Representante Legal
    if (currentUserRole !== 'Representante Legal') {
      return;
    }

    setIsLoadingHistory(true);
    setHistoryError(null);

    try {
      const response = await axios.get('/api/subscriptions/history', {
        params: {
          data_inicio: startDate,
          data_fim: endDate,
          page: page, // Envia a página desejada para a API
        }
      });
      // A resposta agora é um objeto de paginação com a soma total
      setPurchaseHistory(response.data.data || []);
      setHistoryCurrentPage(response.data.current_page);
      setHistoryTotalPages(response.data.last_page);
      setHistoryTotalSum(response.data.total_sum || 0); // Armazena a soma total
      setHistorySearched(true); // Marca que a busca foi realizada
    } catch (err) {
      setHistoryError('Não foi possível carregar o histórico de compras.');
      console.error("Erro ao buscar histórico de compras:", err);
      setPurchaseHistory([]); // Limpa resultados anteriores em caso de erro
      setHistoryTotalSum(0); // Reseta a soma em caso de erro
    } finally {
      setIsLoadingHistory(false);
    }
  }, [currentUserRole, startDate, endDate]); // A página não precisa ser uma dependência aqui

  // 4. useEffect para verificar a atribuição de perfis essenciais (agora com controle para chamada única)
  useEffect(() => {
    const checkAssignments = async () => {
      // CONDIÇÕES PARA EXECUTAR A API:
      // 1. O usuário deve ser 'Representante Legal'.
      // 2. A entidade atual deve estar carregada (ter um ID).
      // 3. A verificação para ESTA entidade específica ainda não pode ter sido feita.
      if (
        currentUserRole === 'Representante Legal' &&
        currentEntidade?.id &&
        assignmentsCheckedForEntityIdRef.current !== currentEntidade.id
      ) {
        // Marca que a verificação para esta entidade está sendo feita para evitar chamadas duplicadas.
        assignmentsCheckedForEntityIdRef.current = currentEntidade.id;
        setAssignmentStatus(prev => ({ ...prev, isLoading: true })); // Mostra o loading

        try {
          const response = await axios.get(`/api/entidades/${currentEntidade.id}/profile-assignments-status`);
          setAssignmentStatus({ isLoading: false, hasReception: response.data.has_reception || false });
        } catch (error) {
          console.error("Erro ao verificar atribuições de perfil:", error);
          setAssignmentStatus({ isLoading: false, hasReception: true }); // Em caso de erro, não mostra o alerta
        }
      } else if (currentUserRole !== 'Representante Legal') {
        // Se o usuário não for RL, simplesmente definimos o estado como carregado e sem alerta.
        setAssignmentStatus({ isLoading: false, hasReception: true });
      }
    };

    checkAssignments();
  }, [currentEntidade, currentUserRole]); // As dependências estão corretas, a lógica interna previne re-execuções.

  // --- INÍCIO: LÓGICA DO MODAL DE AGENDAMENTO (adaptada de AgendasTab) ---

  const handleOpenAppointmentModal = (time, date, busyDoctorIds = []) => {
    const medicoId = currentUserRole === 'Médico' ? currentUser.id : '';
    const medico = todosMedicos.find(m => m.id === medicoId);
    const especialidadeId = medico ? medico.especialidade_id : '';

    setBusyDoctorsForSlot(busyDoctorIds);
    setShowAppointmentModal(true);
    setSelectedServicos([]);
    setPacienteSearch('');
    setNewAppointment({
        entidade_id: currentEntidade.id,
        filial_id: '',
        especialidade_id: especialidadeId,
        medico_id: medicoId,
        paciente_id: '',
        data_agendamento: format(date, 'yyyy-MM-dd'),
        hora_marcada: time,
        tipo: 'Consulta',
        status: 'Agendada',
        interesses: [],
    });
  };

  const handleCloseAppointmentModal = () => {
    setShowAppointmentModal(false);
    setPacienteSearch('');
    setSelectedPackageId(null);
    setBusyDoctorsForSlot([]);
  };

  const handleModalFormChange = (e) => {
    const { name, value } = e.target;
    setNewAppointment(prev => {
      const newState = { ...prev, [name]: value };
      // Se a especialidade mudou, reseta o médico
      if (name === 'especialidade_id') {
        newState.medico_id = '';
      }
      return newState;
    });
  };

  const handleCreateAppointment = async () => {
    if (!newAppointment.paciente_id) {
      showAlertModal('Validação', 'Por favor, selecione um paciente.', 'warning');
      return;
    }
    if (!newAppointment.medico_id) {
      showAlertModal('Validação', 'Por favor, selecione um médico.', 'warning');
      return;
    }
    if (!currentEntidade) {
      showAlertModal('Erro', 'Entidade não carregada. Tente novamente.', 'danger');
      return;
    }

    setIsLoadingCreate(true);

    const data = {
      ...newAppointment,
      servicos: selectedServicos,
      pacote_id: selectedPackageId,
    };
    delete data.interesses;

    try {
      const response = await axios.post('/api/agendamentos', data);

      if (response.status === 201) {
        setRefreshSummary(c => c + 1); // Aciona a atualização do ScheduleSummary
        handleCloseAppointmentModal();
        showAlertModal('Sucesso', 'Agendamento criado com sucesso!', 'success');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Erro ao criar agendamento.';
      showAlertModal('Erro', errorMessage, 'danger');
    } finally {
      setIsLoadingCreate(false);
    }
  };

  const handleServicoChange = (servicoId, pacoteId = null) => {
    const isCurrentlySelected = selectedServicos.includes(servicoId);
    if (pacoteId) {
      if (isCurrentlySelected) {
        setSelectedServicos([]);
        setSelectedPackageId(null);
      } else {
        setSelectedServicos([servicoId]);
        setSelectedPackageId(pacoteId);
      }
    } else {
      if (selectedPackageId) return;
      setSelectedServicos(prev => isCurrentlySelected ? prev.filter(id => id !== servicoId) : [...prev, servicoId]);
    }
  };

  const handleOpenCreatePatientModal = () => setShowCreatePatientModal(true);
  const handleCloseCreatePatientModal = () => setShowCreatePatientModal(false);

  const handleCreatePatient = async () => {
    setIsCreatingPatient(true); // Ativa o loading
    if (!newPatient.nome || !newPatient.dddcelular || !newPatient.celular) {
      showAlertModal('Validação', 'Nome e Celular são obrigatórios.', 'warning');
      setIsCreatingPatient(false); // Desativa o loading em caso de erro de validação
      return;
    }
    try {
      const patientDataWithEntity = { ...newPatient, entidade_id: currentEntidade.id };
      const response = await axios.post('/api/pacientes', patientDataWithEntity);
      const createdPaciente = response.data.paciente;

      // A lista de pacientes agora é gerenciada pelo EntidadeContext. Apenas mostramos o alerta.
      showAlertModal('Sucesso', `Paciente "${createdPaciente.nome}" criado com sucesso!`, 'success');
      handleCloseCreatePatientModal();
      setNewAppointment(prev => ({ ...prev, paciente_id: createdPaciente.id }));
      setPacienteSearch(createdPaciente.nome);
    } catch (error) {
      showAlertModal('Erro', `Erro ao criar paciente: ${error.response?.data?.message || error.message}`, 'danger');
    } finally {
      setIsCreatingPatient(false); // Desativa o loading
    }
  };

  const handleNewPatientInputChange = (e) => {
    const { name, value } = e.target;
    setNewPatient(prev => ({ ...prev, [name]: value }));
  };

  const handleNewPatientPhoneChange = (e) => {
    const value = e.target.value;
    const justNumbers = value.replace(/\D/g, '');
    const ddd = justNumbers.substring(0, 2);
    const number = justNumbers.substring(2);
    setNewPatient(prev => ({ ...prev, dddcelular: ddd, celular: number }));
  };

  const filteredPacientes = useMemo(() => {
    if (!pacienteSearch) return pacientesList;
    const termoNormalizado = normalizeString(pacienteSearch);
    return pacientesList.filter(paciente => normalizeString(paciente.nome).includes(termoNormalizado));
  }, [pacienteSearch, pacientesList]);

  useEffect(() => {
    const fetchPacotes = async () => {
      if (showAppointmentModal && newAppointment.paciente_id) {
        setIsLoadingPacotes(true);
        try {
          const response = await axios.get(`/api/pacientes/${newAppointment.paciente_id}/pacotes-ativos`);
          setPacientePacotesAtivos(response.data.pacotes_ativos || []);
        } catch (error) {
          console.error("Erro ao buscar pacotes do paciente:", error);
          setPacientePacotesAtivos([]);
        } finally {
          setIsLoadingPacotes(false);
        }
      } else {
        setPacientePacotesAtivos([]);
        setSelectedPackageId(null);
      }
    };
    fetchPacotes();
  }, [newAppointment.paciente_id, showAppointmentModal]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pacienteDropdownRef.current && !pacienteDropdownRef.current.contains(event.target)) {
        setShowPacientesDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // --- FIM: LÓGICA DO MODAL DE AGENDAMENTO ---

  const handleSyncUsage = async () => {
    setIsSyncing(true);
    try {
      // A API agora retorna o objeto de assinatura atualizado
      const response = await axios.post('/api/subscriptions/sync-usage');
      // Chama a nova função do contexto para atualizar apenas os dados necessários
      updatePartialSubscription(response.data);
    } catch (error) {
      console.error("Erro ao sincronizar uso:", error);
      // Opcional: Adicionar um alerta de erro para o usuário
    } finally {
      setIsSyncing(false);
    }
  };
  const handleCheckLowStock = async () => {
    if (!currentEntidade?.id) {
      alert('Entidade não encontrada.'); // Ou usar um modal de alerta
      return;
    }

    setIsLoading(true);
    setStockChecked(false); // Reseta para mostrar o spinner corretamente
    try {
      const stockResponse = await axios.get(`/api/estoque/baixo?entidade_id=${currentEntidade.id}`);
      setLowStockMaterials(stockResponse.data.materiais || []);
    } catch (error) {
      console.error("Erro ao buscar materiais com estoque baixo:", error);
      setLowStockMaterials([]);
      // Opcional: mostrar um alerta de erro para o usuário
    } finally {
      setIsLoading(false);
      setStockChecked(true); // Marca que a verificação foi concluída
    }
  };

  // Funções para controlar o modal da Central de Ajuda
  const handleOpenHelpCenterModal = () => setShowHelpCenterModal(true);
  const handleCloseHelpCenterModal = () => {
    setShowHelpCenterModal(false);
    // Reseta todos os vídeos ativos ao fechar o modal para garantir que parem de tocar
    setActiveAgendaVideo(null);
    setActivePacientesVideo(null);
    setActiveFinanceiroVideo(null);
    setActivePessoalVideo(null);
    setActiveSegurancaVideo(null);
    setActiveConfiguracoesVideo(null);
    setActiveAssinaturaVideo(null);
    setHelpSearchTerm(''); // Limpa a busca ao fechar
  };


  // Mostra um spinner geral enquanto os dados da assinatura estão sendo carregados
  if (isLoadingSubscription) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Carregando...</span>
        </Spinner>
      </Container>
    );
  }

  const formatCurrency = (value) => {
    if (value === null || value === undefined) return 'N/A';
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format(value);
  };

  const formatDate = (dateString) => {
      if (!dateString) return 'N/A';
      return new Date(dateString).toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
      });
  };

  const getStatusBadge = (status) => {
      if (status === 'paid') return <Badge bg="success">Pago</Badge>;
      return <Badge bg="secondary">{status || 'N/A'}</Badge>;
  };

  const renderDashboardContent = () => (
     <>
     <Alert variant="success">
        <Alert.Heading>Olá! Bem-vindo(a) de volta.</Alert.Heading>
        <p>
          Seu painel está pronto para uso. Explore as funcionalidades abaixo para gerenciar sua clínica de forma eficiente.
        </p>
      </Alert>

      {/* NOVO ALERTA PARA CADASTRO DE PACIENTE */}
      {currentEntidade && !currentEntidade.has_pacientes && (
        <Alert variant="info" className="mb-2 shadow-sm">
          <Alert.Heading>Próximo Passo: Cadastre seu primeiro Paciente</Alert.Heading>
          <p>
            Sua clínica está configurada! Agora, para começar a usar a agenda e o prontuário, você precisa cadastrar seu primeiro paciente.
          </p>
          <hr />
          <div className="d-flex justify-content-end">
            <Button onClick={() => navigate('/consultorio', { state: { activeTab: 'pacientes' } })} variant="primary">
              Cadastrar Paciente Agora
            </Button>
          </div>
        </Alert>
      )}
      {/* 5. NOVO ALERTA DE ORIENTAÇÃO */}
      {!assignmentStatus.isLoading && !assignmentStatus.hasReception && currentUserRole === 'Representante Legal' && (
        <Alert variant="warning" className="mb-2 shadow-sm">
          <Alert.Heading>Ação Recomendada: Atribua Perfis de Acesso</Alert.Heading>
          <p>
            Para garantir a funcionalidade completa da plataforma, é essencial que pelo menos um colaborador tenha o perfil de <strong>"Recepção"</strong>.
          </p>
          <p className="mb-0">
            O perfil de Recepção é crucial para gerenciar a agenda de todos os médicos, realizar o check-in de pacientes e registrar pagamentos.
          </p>
          <hr />
          <div className="d-flex justify-content-end">
            <Button onClick={() => navigate('/pessoal')} variant="dark" className="ms-2">
              Atribuir a um Colaborador
            </Button>
          </div>
        </Alert>
      )}

      {/* NOVO: Linha para o Resumo da Agenda */}
      {hasPermission('resumo_agenda') && (
        <Row className="mb-2">
          <Col>
            <ScheduleSummary
              onVacantSlotClick={handleOpenAppointmentModal}
              refreshTrigger={refreshSummary}
              currentEntidade={currentEntidade}
              currentUser={currentUser}
              currentUserRole={currentUserRole}
              todosMedicos={todosMedicos}
              getFeriadoNome={getFeriadoNome}
              isDiaBloqueado={isDiaBloqueado}
            />
          </Col>
        </Row>
      )}
      

      {/* Linha para Status da Assinatura e Histórico de Compras (Apenas para Representante Legal) */}
      {(hasPermission('status_assinatura') || hasPermission('historico_assinatura')) && (
        <Row className="g-4">
          {/* Card de Status da Assinatura */}
          
          {hasPermission('status_assinatura') && authState.subscription && (
            <Col md={12} lg={6} className="mb-2">
              <SubscriptionStatusCard 
                subscription={authState.subscription} 
                currentUserRole={currentUserRole}
                onSyncUsage={handleSyncUsage}
                isSyncing={isSyncing}
                navigate={navigate}
              />
            </Col>
          )}

          {/* Card de Histórico de Compras */}
          {hasPermission('historico_assinatura') && (
          <Col md={12} lg={6} className="mb-2">
            <Card className="h-100 shadow-sm">
              <Card.Header>
                <div className="d-flex justify-content-between align-items-center">
                  <Card.Title as="h5" className="mb-0">
                    <span role="img" aria-label="histórico" className="me-2">📜</span>
                    Histórico de compras de créditos avulsos
                  </Card.Title>
                  {historySearched && !isLoadingHistory && purchaseHistory.length > 0 && (
                    <span className="fw-bold">
                      Total do Período: {formatCurrency(historyTotalSum)}
                    </span>
                  )}
                </div>
              </Card.Header>
              <Card.Body className="d-flex flex-column">
                <Form>
                  <Row className="align-items-end mb-2">
                    <Col>
                      <Form.Group controlId="startDate">
                        <Form.Label size="sm">Data Início</Form.Label>
                        <Form.Control type="date" size="sm" value={startDate} onChange={e => setStartDate(e.target.value)} />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group controlId="endDate">
                        <Form.Label size="sm">Data Fim</Form.Label>
                        <Form.Control type="date" size="sm" value={endDate} onChange={e => setEndDate(e.target.value)} />
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="d-grid">
                    <Button variant="primary" onClick={() => handleFetchHistory(1)} disabled={isLoadingHistory}>
                      {isLoadingHistory ? (
                        <><Spinner as="span" animation="border" size="sm" /> Buscando...</>
                      ) : 'Buscar Histórico'}
                    </Button>
                  </div>
                </Form>

                {historyError && <Alert variant="danger" className="mt-3">{historyError}</Alert>}
                
                {historySearched && !isLoadingHistory && !historyError && (
                  purchaseHistory.length === 0 ? (
                    <Alert variant="info" className="mt-3 mb-0">Nenhuma compra de créditos avulsos encontrada para o período.</Alert>
                  ) : (
                    <>
                      <div style={{ maxHeight: '250px', overflowY: 'auto' }} className="mt-3">
                        <Table striped hover responsive size="sm">
                          <thead>
                            <tr>
                              <th>Data</th>
                              <th>Créditos</th>
                              <th className="text-end">Valor</th>
                            </tr>
                          </thead>
                          <tbody>
                            {purchaseHistory.map((item) => (
                              <tr key={item.id || item.pedido_pagarme_id}>
                                <td>{formatDate(item.created_at)}</td>
                                <td className="text-center">{item.appointments_amount}</td>
                                <td className="text-end">{formatCurrency(item.price)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                      {historyTotalPages > 1 && (
                        <Pagination size="sm" className="justify-content-center mt-2">
                          <Pagination.Prev onClick={() => handleFetchHistory(historyCurrentPage - 1)} disabled={historyCurrentPage === 1} />
                          {[...Array(historyTotalPages).keys()].map(number => (
                            <Pagination.Item key={number + 1} active={number + 1 === historyCurrentPage} onClick={() => handleFetchHistory(number + 1)}>
                              {number + 1}
                            </Pagination.Item>
                          ))}
                          <Pagination.Next onClick={() => handleFetchHistory(historyCurrentPage + 1)} disabled={historyCurrentPage === historyTotalPages} />
                        </Pagination>
                      )}
                    </>
                  )
                )}
              </Card.Body>
            </Card>
          </Col>
          )}
        </Row>
      )}

      {/* Renderiza o relatório de comissão apenas se o usuário for comissionável */}
      {hasPermission('comissoes_a_pagar') && (
        <Row className="g-4">
          <Col md={12} className="mb-2">
            <ComissaoRelatorio
              currentEntidade={currentEntidade}
              currentUserRole={currentUserRole}
              allFuncionarios={allFuncionarios}
            />
          </Col>
        </Row>
      )}
      
      {/* Linha para Ações Rápidas e Estoque Baixo */}
      {(hasPermission('acoes_agendas') || hasPermission('acoes_financeiro') || hasPermission('acoes_equipe') || hasPermission('acoes_auditoria') || hasPermission('central_ajuda') || hasPermission('estoque_baixo')) && (

        <Row className="g-4">
          {/* Card de Ações Rápidas */}
          {(hasPermission('acoes_agendas') || hasPermission('acoes_financeiro') || hasPermission('acoes_equipe') || hasPermission('acoes_auditoria') || hasPermission('central_ajuda')) && (
          <Col md={12} lg={6} className="mb-4">
            <Card className="h-100 shadow-sm">
              <Card.Body>
                <Card.Title>Ações Rápidas</Card.Title>
                <Card.Text>Acesse as principais áreas do sistema com um clique.</Card.Text>
                <div className="d-grid gap-2">
                  {hasPermission('acoes_agendas') && (
                  <Button variant="primary" onClick={() => navigate('/consultorio', { state: { activeTab: 'agenda' } })}>
                    <span role="img" aria-label="calendário" className="h5 me-2">📅</span> Ir para Agenda e Consultas
                  </Button>
                  )}
                  {hasPermission('acoes_financeiro') && (
                    <Button variant="outline-secondary" onClick={() => navigate('/financeiro')}>
                      <span role="img" aria-label="dinheiro" className="h5 me-2">💰</span> Acessar Financeiro
                    </Button>
                  )}
                  {hasPermission('acoes_equipe') && (
                    <Button variant="outline-secondary" onClick={() => navigate('/pessoal')}>
                      <span role="img" aria-label="pessoas" className="h5 me-2">👥</span> Gerenciar Equipe
                    </Button>
                  )}
                  {hasPermission('acoes_auditoria') && (
                    <Button variant="outline-dark" onClick={() => navigate('/auditoria')}>
                      <span role="img" aria-label="olho" className="h5 me-2">👁️</span> Ver Logs de Auditoria
                    </Button>
                  )}
                  {hasPermission('central_ajuda') && (
                  <Button variant="outline-info" onClick={handleOpenHelpCenterModal}>
                    <span role="img" aria-label="ajuda" className="h5 me-2">💡</span> Central de Ajuda
                  </Button>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
          )}

          {/* Card de Estoque Baixo */}
          {hasPermission('estoque_baixo') && (
          <Col md={12} lg={6} className="mb-4">
            <Card className="h-100 shadow-sm">
              <Card.Header>
                <Card.Title as="h5">
                  <span role="img" aria-label="alerta" className="me-2">⚠️</span>
                  Verificar Estoque Baixo
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <p>Clique no botão para verificar se há materiais que atingiram o nível mínimo de estoque.</p>
                <Button variant="warning" onClick={handleCheckLowStock} disabled={isLoading}>
                  {isLoading ? (
                    <>
                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                      Verificando...
                    </>
                  ) : 'Verificar Estoque Agora'}
                </Button>

                {/* A tabela só aparece após a verificação */}
                {stockChecked && !isLoading && (
                  <div className="mt-4">
                    {lowStockMaterials.length > 0 ? (
                      <>
                        <Alert variant="warning">
                          <strong>Atenção!</strong> Os seguintes materiais atingiram ou estão abaixo do nível mínimo de estoque. Considere fazer um novo pedido.
                        </Alert>
                        <Table striped hover responsive size="sm">
                          <thead>
                            <tr>
                              <th>Material</th>
                              <th className="text-center">Estoque Atual</th>
                              <th className="text-center">Estoque Mínimo</th>
                            </tr>
                          </thead>
                          <tbody>
                            {lowStockMaterials.map(material => (
                              <tr key={material.id}>
                                <td>{material.tipo_material.nome}</td>
                                <td className="text-center fw-bold text-danger">{material.quantidade_em_estoque} {material.tipo_material.unidade_medida}</td>
                                <td className="text-center">{material.estoque_minimo} {material.tipo_material.unidade_medida}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                        <div className="text-end mt-3">
                          <Button variant="outline-primary" onClick={() => navigate('/estoque')}>Gerenciar Estoque</Button>
                        </div>
                      </>
                    ) : (
                      <Alert variant="success" className="mt-3">
                        Nenhum material com estoque baixo encontrado.
                      </Alert>
                    )}
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
          )}
        </Row>
      )}
    </>
  );

  // O loading geral da página agora só depende da entidade
  if (!currentEntidade) {
    return (
      <Container fluid className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Carregando...</span>
        </Spinner>
      </Container>
    );
  }

  return (
    <>
      <Container fluid className="p-4">
        {/* A decisão agora é baseada na flag 'has_pacientes' que vem do contexto da entidade */}
        {renderDashboardContent()}
      </Container>

      {/* --- INÍCIO: MODAIS DE AGENDAMENTO E CRIAÇÃO DE PACIENTE --- */}
      <Modal show={showAppointmentModal} onHide={handleCloseAppointmentModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Novo Agendamento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Seletor de Médico/Especialidade para Recepção/Admin */}
            {(currentUserRole === 'Representante Legal' || currentUserRole === 'Recepção') && (
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group controlId="modalEspecialidade">
                    <Form.Label>Especialidade: *</Form.Label>
                    <Form.Control as="select" name="especialidade_id" value={newAppointment.especialidade_id} onChange={handleModalFormChange} required>
                      <option value="">Selecione...</option>
                      {especialidades.map(esp => <option key={esp.id} value={esp.id}>{esp.nome}</option>)}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="modalMedico">
                    <Form.Label>Médico: *</Form.Label>
                    <Form.Control as="select" name="medico_id" value={newAppointment.medico_id} onChange={handleModalFormChange} required disabled={!newAppointment.especialidade_id}>
                      <option value="">Selecione a especialidade</option>
                      {todosMedicos
                        .filter(m => m.especialidade_id === parseInt(newAppointment.especialidade_id))
                        .filter(m => !busyDoctorsForSlot.includes(m.id))
                        .map(med => <option key={med.id} value={med.id}>{med.nome}</option>)}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>
            )}

            {/* Busca de Paciente */}
            <Row className="align-items-center mb-3">
              <Col xs={12} sm={10} className="mb-2 mb-sm-0">
                <Form.Group controlId="paciente" ref={pacienteDropdownRef} style={{ position: 'relative' }}>
                  <Form.Label>Paciente: *</Form.Label>
                  <Form.Control
                    type="text" placeholder="Digite para buscar um paciente..." value={pacienteSearch}
                    onChange={(e) => {
                      setPacienteSearch(e.target.value);
                      setShowPacientesDropdown(true);
                      if (newAppointment.paciente_id) {
                        setNewAppointment({ ...newAppointment, paciente_id: '' });
                        setSelectedPackageId(null);
                        setSelectedServicos([]);
                      }
                    }}
                    onFocus={() => setShowPacientesDropdown(true)} required={!newAppointment.paciente_id} autoComplete="off"
                  />
                  {showPacientesDropdown && (
                    <ListGroup className="paciente-dropdown">
                      {filteredPacientes.length > 0 ? (
                        filteredPacientes.slice(0, 6).map(patient => (
                          <ListGroup.Item key={patient.id} action onClick={() => {
                              setNewAppointment({ ...newAppointment, paciente_id: patient.id });
                              setPacienteSearch(patient.nome);
                              setShowPacientesDropdown(false);
                            }}
                          >{patient.nome}</ListGroup.Item>
                        ))
                      ) : (<ListGroup.Item disabled>Nenhum paciente encontrado.</ListGroup.Item>)}
                    </ListGroup>
                  )}
                </Form.Group>
              </Col>
              <Col xs={12} sm={2} className="text-sm-end mt-2 mt-sm-0 d-flex align-items-end justify-content-center justify-content-sm-end">
                <img src={addPatientIcon} alt="Cadastrar novo paciente" title='Cadastrar novo paciente' style={{ width: '30px', height: '30px', cursor: 'pointer' }} onClick={handleOpenCreatePatientModal} />
              </Col>
            </Row>

            {/* Data e Hora */}
            <Row className="mb-3">
              <Col xs={12} sm={6}><Form.Group controlId="data"><Form.Label>Data:</Form.Label><Form.Control type="text" value={newAppointment.data_agendamento ? new Date(newAppointment.data_agendamento + 'T00:00:00').toLocaleDateString('pt-BR') : ''} readOnly /></Form.Group></Col>
              <Col xs={12} sm={6}><Form.Group controlId="hora"><Form.Label>Hora:</Form.Label><Form.Control type="text" value={newAppointment.hora_marcada || ''} readOnly /></Form.Group></Col>
            </Row>

            {/* Serviços e Pacotes */}
            {isLoadingPacotes ? (
              <div className="text-center my-2"><Spinner size="sm" /><span> Verificando pacotes...</span></div>
            ) : pacientePacotesAtivos.length > 0 && (
              <Alert variant="info">Este paciente possui pacotes ativos. Ao selecionar um serviço do pacote, um crédito será utilizado.</Alert>
            )}
            {/* --- INÍCIO DA REFATORAÇÃO --- */}
            <Form.Group controlId="servicos" className="mb-3">
              <Form.Label>Serviços:</Form.Label>
              <Select
                isMulti
                options={servicos.map(servico => {
                  const pacoteAtivo = pacientePacotesAtivos.find(p => p.servico_id === servico.id);
                  const label = `${servico.nome}${pacoteAtivo ? ` (Pacote - ${pacoteAtivo.sessoes_restantes} restantes)` : ''}`;
                  return {
                    value: servico.id,
                    label: label,
                    pacoteId: pacoteAtivo ? pacoteAtivo.id : null,
                    isDisabled: !pacoteAtivo && selectedPackageId !== null
                  };
                })}
                value={servicos.filter(s => selectedServicos.includes(s.id)).map(s => ({ value: s.id, label: s.nome }))}
                onChange={(selectedOptions) => {
                  const lastSelected = selectedOptions[selectedOptions.length - 1];
                  handleServicoChange(lastSelected?.value, lastSelected?.pacoteId);
                }}
                placeholder="Digite para buscar e selecionar serviços..."
                noOptionsMessage={() => 'Nenhum serviço encontrado'}
              />
            </Form.Group>
            {/* --- FIM DA REFATORAÇÃO --- */}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseAppointmentModal}>Cancelar</Button>
          <Button variant="primary" onClick={handleCreateAppointment} disabled={isLoadingCreate}>
            {isLoadingCreate ? <><Spinner as="span" size="sm" /> Agendando...</> : 'Agendar'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showCreatePatientModal} onHide={handleCloseCreatePatientModal}>
        <Modal.Header closeButton>
          <Modal.Title>Cadastrar Novo Paciente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="formNomePaciente">
              <Form.Label>Nome: *</Form.Label>
              <Form.Control type="text" name="nome" value={newPatient.nome} onChange={handleNewPatientInputChange} required />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formCelularPaciente">
              <Form.Label>Celular: *</Form.Label>
              <InputMask mask="(99) 99999-9999" value={`${newPatient.dddcelular}${newPatient.celular}`} onChange={handleNewPatientPhoneChange}>
                {(inputProps) => <Form.Control {...inputProps} type="tel" required />}
              </InputMask>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formEmailPaciente">
              <Form.Label>Email:</Form.Label>
              <Form.Control type="email" name="email" value={newPatient.email} onChange={handleNewPatientInputChange} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formNascimentoPaciente">
              <Form.Label>Data de Nascimento:</Form.Label>
              <Form.Control type="date" name="data_nascimento" value={newPatient.data_nascimento} onChange={handleNewPatientInputChange} />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseCreatePatientModal}>Cancelar</Button>
          <Button variant="primary" onClick={handleCreatePatient} disabled={isCreatingPatient}>
            {isCreatingPatient ? <Spinner as="span" animation="border" size="sm" /> : null}
            {isCreatingPatient ? ' Cadastrando...' : 'Cadastrar'}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* --- FIM: MODAIS --- */}

      {/* Modal da Central de Ajuda com busca */}
      <HelpCenterModal
        show={showHelpCenterModal}
        onHide={handleCloseHelpCenterModal}
        searchTerm={helpSearchTerm}
        onSearchChange={(e) => setHelpSearchTerm(e.target.value)}
        activeKeys={{
          agenda: activeAgendaVideo,
          pacientes: activePacientesVideo,
          financeiro: activeFinanceiroVideo,
          pessoal: activePessoalVideo,
          estoque: activeEstoqueVideo,
          seguranca: activeSegurancaVideo,
          configuracoes: activeConfiguracoesVideo,
          assinatura: activeAssinaturaVideo,
        }}
        onSelectHandlers={{
          agenda: setActiveAgendaVideo,
          pacientes: setActivePacientesVideo,
          financeiro: setActiveFinanceiroVideo,
          pessoal: setActivePessoalVideo,
          estoque: setActiveEstoqueVideo,
          seguranca: setActiveSegurancaVideo,
          configuracoes: setActiveConfiguracoesVideo,
          assinatura: setActiveAssinaturaVideo,
        }}
      />
    </>
  );
};

// --- COMPONENTE DO MODAL DA CENTRAL DE AJUDA ---

const allHelpTopics = [
  {
    categoryKey: '0', categoryTitle: '🗓️ Agenda e Atendimento', stateKey: 'agenda',
    items: [
      { itemKey: '0-1', title: 'Como visualizar a agenda da semana?', videoId: '4sSePNyXtCs' },
      { itemKey: '0-2', title: 'Como realizar um agendamento?', videoId: 'nPHStgMJswk' },
      // { itemKey: '0-3', title: 'Como utilizar o Painel de Chamada?', videoId: '' },
      { itemKey: '0-4', title: 'Por que realizar check-in no agendamento?', videoId: '9EkLIuLWH7k' },
      { itemKey: '0-5', title: 'Como registrar a consulta no prontuário?', videoId: 'kKNZsb-0E1U' },
    ]
  },
  {
    categoryKey: '1', categoryTitle: '👥 Pacientes e Convênios', stateKey: 'pacientes',
    items: [
      // { itemKey: '1-1', title: 'Como importar pacientes em lote?', videoId: 'VIDEO_ID' },
      { itemKey: '1-2', title: 'Como cadastrar um convênio?', videoId: '5OM9A8YUjvg' },
      { itemKey: '1-3', title: 'Como vincular um serviço a um convênio?', videoId: '5OM9A8YUjvg' },
      { itemKey: '1-4', title: 'Como vincular um convênio a um paciente?', videoId: '1lfkBNSrGR4' },
    ]
  },
  {
    categoryKey: '2', categoryTitle: '💰 Financeiro', stateKey: 'financeiro',
    items: [
      { itemKey: '2-1', title: 'Como realizar um pagamento?', videoId: 'e_MTXpr52F0' },
      { itemKey: '2-2', title: 'Como cancelar um pagamento?', videoId: 'KfDYAEJ2Rsg' },
      { itemKey: '2-3', title: 'Como dar desconto em um pagamento?', videoId: 'e_MTXpr52F0' },
      // { itemKey: '2-4', title: 'Como controlar convênios a receber?', videoId: 'VIDEO_ID' },
      { itemKey: '2-5', title: 'Como lançar despesas da clínica?', videoId: 'h4_PpNr_bS8' },
      // { itemKey: '2-6', title: 'Como visualizar pagamentos por período/serviço?', videoId: 'VIDEO_ID' },
      // { itemKey: '2-7', title: 'Como visualizar Relatório DRE ou Fluxo de Caixa?', videoId: 'VIDEO_ID' },
      // { itemKey: '2-8', title: 'Como analisar Custos e Despesas?', videoId: 'VIDEO_ID' },
    ]
  },
  // {
  //   categoryKey: '3', categoryTitle: '👨‍💼 Pessoal e Comissões', stateKey: 'pessoal',
  //   items: [
      // { itemKey: '3-0', title: 'Como adicionar mais médicos para o agendamento?', videoId: 'VIDEO_ID' },
      // { itemKey: '3-1', title: 'Como cadastrar um Recepcionista?', videoId: 'VIDEO_ID' },
      // { itemKey: '3-2', title: 'Como criar um perfil com acessos específicos?', videoId: 'VIDEO_ID' },
      // { itemKey: '3-3', title: 'Como cadastrar o salário de um funcionário?', videoId: 'VIDEO_ID' },
      // { itemKey: '3-4', title: 'Como cadastrar um adiantamento para funcionário?', videoId: 'VIDEO_ID' },
      // { itemKey: '3-5', title: 'Como gerar uma folha de pagamento?', videoId: 'VIDEO_ID' },
      // { itemKey: '3-6', title: 'Por que processar uma folha de pagamento?', videoId: 'VIDEO_ID' },
      // { itemKey: '3-7', title: 'Como cadastrar um funcionário para receber comissão?', videoId: 'VIDEO_ID' },
      // { itemKey: '3-8', title: 'Como vincular serviços passíveis de comissão?', videoId: 'VIDEO_ID' },
      // { itemKey: '3-9', title: 'Como limitar a % de comissão de um serviço?', videoId: 'VIDEO_ID' },
      // { itemKey: '3-10', title: 'Como alterar o titular de uma comissão?', videoId: 'VIDEO_ID' },
      // { itemKey: '3-11', title: 'Como vincular uma comissão de indicação?', videoId: 'VIDEO_ID' },
      // { itemKey: '3-12', title: 'Como confirmar uma comissão?', videoId: 'VIDEO_ID' },
  //   ]
  // },
  // {
  //   categoryKey: '4', categoryTitle: '📦 Serviços e Estoque', stateKey: 'estoque',
  //   items: [
      // { itemKey: '4-1', title: 'Como automatizar o controle de estoque?', videoId: 'wEnYgQ-VZRs', description: 'Para que o sistema deduza o estoque automaticamente, siga 3 passos:\n1. **Cadastre seus Materiais:** Em `Estoque > Materiais`, adicione seus produtos com a **quantidade** e o **valor de compra**.\n2. **Cadastre seus Serviços:** Em `Serviços`, crie os procedimentos que você oferece.\n3. **Vincule Materiais aos Serviços:** Ao editar um serviço, associe os materiais e as quantidades que são utilizadas nele.' },
      // { itemKey: '4-2', title: 'Como cadastrar um serviço com mais de uma sessão (pacote)?', videoId: 'VIDEO_ID' },
      // { itemKey: '4-3', title: 'Como vincular um serviço com sessões já pagas?', videoId: 'VIDEO_ID' },
      // { itemKey: '4-4', title: 'Como informar o estoque mínimo de um material?', videoId: 'VIDEO_ID' },
      // { itemKey: '4-5', title: 'Como realizar um ajuste de estoque (Ajuste ou Perda)?', videoId: 'VIDEO_ID' },
  //   ]
  // },
  // {
  //   categoryKey: '5', categoryTitle: '🛡️ Segurança e Auditoria', stateKey: 'seguranca',
  //   items: [
      // { itemKey: '5-1', title: 'Como visualizar quem alterou ou deletou um registro?', videoId: 'VIDEO_ID' },
  //   ]
  // },
  // {
  //   categoryKey: '6', categoryTitle: '⚙️ Configurações e Comunicação', stateKey: 'configuracoes',
  //   items: [
      // { itemKey: '6-1', title: 'Como configurar SMTP para envio de comunicados?', videoId: 'VIDEO_ID' },
      // { itemKey: '6-2', title: 'Como cadastrar tags de interesse?', videoId: 'VIDEO_ID' },
      // { itemKey: '6-3', title: 'Como vincular interesses a um paciente?', videoId: 'VIDEO_ID' },
      // { itemKey: '6-4', title: 'Como enviar comunicado por interesses em comum?', videoId: 'VIDEO_ID' },
      // { itemKey: '6-5', title: 'Como enviar comunicado por data de nascimento?', videoId: 'VIDEO_ID' },
  //   ]
  // },
  // {
  //   categoryKey: '7', categoryTitle: '💳 Assinatura e Créditos', stateKey: 'assinatura',
  //   items: [
      // { itemKey: '7-1', title: 'Como contratar uma assinatura?', videoId: 'VIDEO_ID' },
      // { itemKey: '7-2', title: 'Como adquirir créditos adicionais?', videoId: 'VIDEO_ID' },
  //   ]
  // },
];

const HelpCenterModal = ({ show, onHide, searchTerm, onSearchChange, activeKeys, onSelectHandlers }) => {
  const filteredTopics = useMemo(() => {
    if (!searchTerm) {
      return allHelpTopics;
    }
    const normalizedSearch = normalizeString(searchTerm);
    return allHelpTopics
      .map(category => {
        const filteredItems = category.items.filter(item =>
          normalizeString(item.title).includes(normalizedSearch)
        );
        if (filteredItems.length > 0) {
          return { ...category, items: filteredItems };
        }
        return null;
      })
      .filter(Boolean);
  }, [searchTerm]);

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <span role="img" aria-label="ajuda" className="me-2">💡</span> Central de Ajuda
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="lead">Bem-vindo! Encontre vídeos curtos e guias para aproveitar ao máximo as funcionalidades do sistema.</p>
          <Form.Control
            type="text"
            placeholder="Pesquisar tópico..."
            className="mb-3"
            value={searchTerm}
            onChange={onSearchChange}
          />

          <Accordion defaultActiveKey={searchTerm ? filteredTopics.map(c => c.categoryKey) : []} alwaysOpen={!!searchTerm}>
            {filteredTopics.length > 0 ? (
              filteredTopics.map(category => (
                <Accordion.Item eventKey={category.categoryKey} key={category.categoryKey}>
                  <Accordion.Header>{category.categoryTitle}</Accordion.Header>
                  <Accordion.Body>
                    <Accordion flush activeKey={activeKeys[category.stateKey]} onSelect={onSelectHandlers[category.stateKey]}>
                      {category.items.map(item => (
                        <Accordion.Item eventKey={item.itemKey} key={item.itemKey}>
                          <Accordion.Header as="h6">{item.title}</Accordion.Header>
                          <Accordion.Body>
                            {item.description && <p style={{ whiteSpace: 'pre-line' }}>{item.description}</p>}
                            <div className="ratio ratio-16x9">
                              <iframe
                                src={activeKeys[category.stateKey] === item.itemKey ? `https://www.youtube.com/embed/${item.videoId}` : ""}
                                title={item.title}
                                allowFullScreen
                              ></iframe>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                    </Accordion>
                  </Accordion.Body>
                </Accordion.Item>
              ))
            ) : (
              <Alert variant="info">Nenhum tópico encontrado para "<strong>{searchTerm}</strong>".</Alert>
            )}
          </Accordion>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Fechar
          </Button>
        </Modal.Footer>
    </Modal>
  );
};

export default DashboardPage;
